export default defineNuxtRouteMiddleware((to, from) => {
  // skip middleware on server
  if (import.meta.server) {
    return
  }

  if (import.meta.client) {
    const userStore = useUserStore()
    if (getLocal('token') && getLocal('auth_user')) {
      const user = JSON.parse(getLocal('auth_user')) || {}
      /*
             | =============================
             | Onboarding user journey cases
             | @type {boolean|boolean}
             | =============================
             */
      const isOnboarding = Object.keys(user).length && !user.profile?.onboardingCompleted && !user.profile?.onboardingSkipped
      if (isOnboarding) {
        if (to.name !== 'dashboard-onboarding' && (!userStore.getOnBoardingFormData || !Object.keys(userStore.getOnBoardingFormData).length)) {
          return navigateTo('/dashboard/onboarding/', { external: true })
        }
      } else if (['login', 'dashboard-login', 'register','dashboard-register', 'dashboard-onboarding', 'verify', 'forgot-password', 'dashboard-forgot-password', 'authorization-callback', 'dashboard-authorization-callback', 'authorization-merge', 'dashboard-authorization-merge'].includes(to.name)) {
        return navigateTo('/dashboard', { external: true })
      }
    } else if (to.path.includes('/dashboard') && !['dashboard-login','dashboard-register', 'dashboard-forgot-password', 'dashboard-reset-password'].includes(to.name)) {
      return navigateTo(generateLoginPageUrl(), { external: true })
    }
  }
})
